import React from 'react';

const AppShowcase = () => {
  return (
    <div className="app-showcase">
      <div className="phone-mockup">
        <div className="phone-screen">
          <div className="screen-content">
            <div className="app-icon">
              <i className="fas fa-hotel"></i>
            </div>
            <h3 className="app-title">Hotel Booking App</h3>
            <p className="app-description">A Flutter-based hotel booking application with beautiful UI and smooth animations.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppShowcase;